import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { ActivateAccountComponent } from './account/components';
import { FooterPublicComponent } from './layout/footer-public/footer-public.component';
import { HeaderPublicComponent } from './layout/header-public/header-public.component';
import { LayoutPublicComponent } from './layout/layout-public/layout-public.component';
import { OktaCallbackComponent } from './login/callback.component';
import { LoginComponent } from './login/login.component';
import { publicRoutes } from './public.routes';

@NgModule({
  declarations: [
    FooterPublicComponent,
    HeaderPublicComponent,
    LayoutPublicComponent,
    LoginComponent,
    ActivateAccountComponent,
    OktaCallbackComponent
  ],
  imports: [SharedModule,
    RouterModule.forChild(publicRoutes)],

})
export class PublicModule { }
